import type { PreguntaSeo } from "@/components/site/CategoriaSeoPage";
import type { Producto } from "@/lib/productos";

type HeadConfig = {
  path: string;
  title: string;
  description: string;
  ogTitle: string;
  ogDescription: string;
  image: string;
  breadcrumb: string;
  products: Producto[];
  faqs: PreguntaSeo[];
};

export function crearHeadCategoriaSeo(config: HeadConfig) {
  const canonical = `https://pymevisible.cl${config.path}`;

  return {
    meta: [
      { title: config.title },
      { name: "description", content: config.description },
      { property: "og:title", content: config.ogTitle },
      { property: "og:description", content: config.ogDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical },
      { property: "og:image", content: `https://pymevisible.cl${config.image}` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: config.ogTitle },
      { name: "twitter:description", content: config.ogDescription },
      { name: "twitter:image", content: `https://pymevisible.cl${config.image}` },
    ],
    links: [{ rel: "canonical", href: canonical }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "CollectionPage",
              "@id": `${canonical}#webpage`,
              url: canonical,
              name: config.ogTitle,
              description: config.description,
              isPartOf: { "@id": "https://pymevisible.cl/#website" },
            },
            {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Inicio",
                  item: "https://pymevisible.cl/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: config.breadcrumb,
                  item: canonical,
                },
              ],
            },
            {
              "@type": "FAQPage",
              mainEntity: config.faqs.map(({ pregunta, respuesta }) => ({
                "@type": "Question",
                name: pregunta,
                acceptedAnswer: { "@type": "Answer", text: respuesta },
              })),
            },
          ],
        }),
      },
    ],
  };
}
